// extracted by mini-css-extract-plugin
module.exports = {"container":"BackLink_container__1RnIn"};